import { format, formatDistanceToNowStrict, isFuture, parseISO } from 'date-fns';

/**
 * Format an integer minor-unit amount (e.g. ngwee) as currency.
 * Defaults to Zambian Kwacha and the en-ZM locale so it renders the "K" symbol.
 * Never uses floats for money math.
 */
export function formatMoney(amountMinor: number, currency = 'ZMW'): string {
  try {
    return new Intl.NumberFormat('en-ZM', { style: 'currency', currency }).format(amountMinor / 100);
  } catch {
    return `${currency} ${(amountMinor / 100).toFixed(2)}`;
  }
}

/** Compact number for impact stats, e.g. 1_250 → "1.25K". */
export function formatCompact(value: number): string {
  return new Intl.NumberFormat(undefined, { notation: 'compact', maximumFractionDigits: 1 }).format(
    value,
  );
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return format(parseISO(iso), 'PP');
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  return format(parseISO(iso), "PP 'at' p");
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = parseISO(iso);
  const suffix = isFuture(date) ? 'from now' : 'ago';
  return `${formatDistanceToNowStrict(date)} ${suffix}`;
}
